export default __webpack_public_path__ + "static/media/proximanova-regular.fd4e0c28.otf";